import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { PopUpView, Button } from '~/components';
import { theme } from '~/styles/theme';
import images from '~/constants/images';
import { browserWarning } from '~/static/browserWarning';
import { sanitize } from '@laliga-cdac/react';
import * as S from './styles';
import { useBrowserModal } from './hooks';

export default function BrowserWarningModal() {
  const lang = i18n.language;
  const { showModal, closeModal } = useBrowserModal(true);
  const { t } = useTranslation();

  return (
    <PopUpView
      isOpen={showModal}
      onClose={closeModal}
      zone="whole"
      fullWidth={window.innerWidth <= theme.breakpoints.sm}
    >
      <S.Content>
        <S.WarningImage src={images.warning} alt="warning" />
        <S.Title>{browserWarning[lang].title}</S.Title>
        <div dangerouslySetInnerHTML={sanitize(browserWarning[lang].text)} />
        <S.Footer>
          <Button onClick={closeModal}>{t('close')}</Button>
        </S.Footer>
      </S.Content>
    </PopUpView>
  );
}
